/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';

const EditPostSettings = createContext( {} );
export default EditPostSettings;
